import { z } from 'zod'

export const ADMINPERSONABASEGET_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaBaseGetResponseSchema = z.unknown()
export type AdminPersonaBaseGetResponse = z.infer<typeof adminPersonaBaseGetResponseSchema>
